<template>
  <div class="containers">
    <div v-if="goArea == true" class="area-list">
      <CAlert
          v-if="success == true"
          :show.sync="currentAlertCounter"
          closeButton
          style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
      >
        {{ alertMess }}
      </CAlert>
      <CAlert
          v-else
          :show.sync="currentAlertCounter"
          closeButton
          style="background-color:red;border-radius:0;text-align:center;color:white"
      >
        {{ alertMess }}
      </CAlert>
      <div class="search-area">
        <CRow class="no-gutters">
          <CCol sm="3" style="padding-right:4px">
            <input type="text" v-model="searchValue" placeholder="Nama Pegawai / NIP" class="form-control"/>
          </CCol>
          <CCol sm="3" style="padding-right:4px;padding-left:4px">
            <div class="autocomplete">
              <input type="text"
                     class="form-control"
                     @click="toggleVisibleUnitSearch()"
                     @blur="toggleCloseVisibleUnitSearch()"
                     v-text="selectedItemUnitSearch ? selectedItemUnitSearch['text'] : ''"
                     v-model="queryUnitSearch"
                     @keydown.up="upUnitSearch"
                     @keydown.down="downUnitSearch"
                     @keydown.enter="selectItemUnitSearch"
                     placeholder="Pilih Unit Level"
              >
              <div class="popovers" v-show="visibleUnitSearch">
                <div class="options" v-if="matchesUnitSearch.length != 0 && queryUnitSearch.length != 0"
                     ref="optionsList">
                  <ul>
                    <li v-for="(match, index) in matchesUnitSearch"
                        :key="index"
                        :class="{ 'selected': (selectedUnitSearch == index)}"
                        @click="itemClickedUnitSearch(index)"
                        v-text="match['text']"></li>
                  </ul>
                </div>
                <div class="options" v-if="matchesUnitSearch.length == 0 && queryUnitSearch.length != 0">
                  Data Tidak Ditemukan
                </div>
                <div class="options" v-if="matchesUnitSearch.length == 0 && queryUnitSearch.length == 0">
                  Start Typing...
                </div>
              </div>
            </div>
          </CCol>
          <CCol sm="2" style="padding-right:4px;padding-left:4px">
            <input type="text" v-model="searchJobPosition" placeholder="Jabatan" class="form-control"/>
          </CCol>
          <CCol sm="2" style="padding-right:10px;padding-left:4px">
            <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataStatus" class="form-control"
                          v-model="filterStatus" placeholder="Pilih Status"></model-select>
          </CCol>
          <CCol sm="2">
            <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
          </CCol>
        </CRow>
      </div>
      <div class="sticky1">
        <CRow class="no-gutters">
          <CCol sm="2" class="pr-4">
                    <span>
                        <CButton type="button" @click="goSyncEmp()"
                                 class="btn btn-add">Sinkron</CButton>
                    </span>
          </CCol>
          <CCol sm="2" style="align-content: center">
            <img class="mr-4" @click="reload()" title="refresh" :src="refreshIcon" :class="classReload"
                 width="20px" height="20px" style="cursor:pointer;float:left; align-items: center"/>
            <img class="mr-4" v-if="datas.length != 0" @click="getDownload()" style="float:left;cursor:pointer; align-items: center"
                 :src="downloadIcon" title="export to excel" width="20px" height="20px"/>
            <img class="mr-4" style="float:left; align-items: center" :src="moreIcon" width="20px" height="20px"/>
          </CCol>
          <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon
                            :icon="{prefix: 'fas', iconName: 'chevron-left'}"/></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon
                            :icon="{prefix: 'fas', iconName: 'chevron-left'}"/></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon
                            :icon="{prefix: 'fas', iconName: 'chevron-right'}"/></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon
                            :icon="{prefix: 'fas', iconName: 'chevron-right'}"/></CButton>
                    </span>
            <input @change="validatePage(page)" v-if="totalPage != 1"
                   style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page"
                   class="text-center rounded p-1" type="text">
            <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right"
                   v-model="page" class="text-center rounded p-1" type="text">
            <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span
                style="color:rgba(16, 16, 16, 1)">{{ firstPage }} - {{ lastPage }}</span> of {{ totalRow }}</span>
          </CCol>
          <CCol sm="2">
            <CButton @click="moving()" type="button" class="btn btn-add">Tambah</CButton>
          </CCol>
        </CRow>
      </div>
      <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable"
              :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
      <CRow class="area-back">
        <CCol sm="12">
          <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px"
               style="float:left;cursor:pointer"/>
        </CCol>
      </CRow>
      <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
      <CRow class="area-input">
        <CCol sm="12">
          <CRow>
            <CCol sm="6">
              <label>Nama Pegawai</label>
              <input
                  class="form-control"
                  v-model.trim="$v.namaPegawai.$model"
                  :class="{ 'is-invalid':$v.namaPegawai.$error, 'is-valid': !$v.namaPegawai.$invalid }"
                  placeholder="Nama Pegawai"
                  type="text"
              />
            </CCol>
            <CCol sm="6">
              <label>Nomor Induk Pegawai</label>
              <input
                  class="form-control"
                  v-model.trim="$v.nik.$model"
                  :class="{ 'is-invalid':$v.nik.$error, 'is-valid': !$v.nik.$invalid }"
                  placeholder="NIP"
                  type="text"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="6">
              <label>Email</label>
              <input
                  class="form-control"
                  v-model.trim="$v.email.$model"
                  :onkeyup="this.email = this.email.toLowerCase()"
                  style="text-transform: lowercase"
                  :class="{ 'is-invalid':$v.email.$error, 'is-valid': !$v.email.$invalid }"
                  placeholder="Email"
                  type="text"
              />
            </CCol>
            <CCol sm="6">
              <label>Validasi Email</label>
              <input
                  class="form-control mr-2"
                  v-model.trim="$v.emailValidasi.$model"
                  :class="{ 'is-invalid':$v.emailValidasi.$error, 'is-valid': !$v.emailValidasi.$invalid }"
                  placeholder="Validasi Email"
                  type="text"
              />
            </CCol>
          </CRow>
          <CRow>
            <!-- <CCol sm="6">
                <label>Username</label>
                <input
                    class="form-control"
                    v-model.trim="$v.username.$model"
                    :class="{ 'is-invalid':$v.username.$error, 'is-valid': !$v.username.$invalid }"
                    placeholder="Username"
                    type="text"
                />
            </CCol> -->
            <CCol sm="6">
              <label>Username By</label>
              <model-select :options="dataUsernameBy"
                            class="form-control model-select"
                            v-model.trim="$v.usernameBy.$model"
                            :class="{ 'is-invalid select-invalid':$v.usernameBy.$error, 'is-valid select-valid': !$v.usernameBy.$invalid }"
                            placeholder="Pilih Username By">
              </model-select>
            </CCol>
            <CCol sm="6">
              <label>Telp</label>
              <input
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                  max="13"
                  class="form-control"
                  v-model.trim="$v.telp.$model"
                  :class="{ 'is-invalid':$v.telp.$error, 'is-valid': !$v.telp.$invalid }"
                  placeholder="No. Telp"
                  type="text"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="6">
              <label>Jenis Kelamin</label>
              <model-select :options="dataSex"
                            class="form-control model-select"
                            v-model.trim="$v.sex.$model"
                            :class="{ 'is-invalid select-invalid':$v.sex.$error, 'is-valid select-valid': !$v.sex.$invalid }"
                            placeholder="Pilih Jenis Kelamin">
              </model-select>
            </CCol>
            <CCol sm="6">
              <label>Alamat</label>
              <input
                  class="form-control"
                  v-model.trim="$v.alamat.$model"
                  :class="{ 'is-invalid':$v.alamat.$error, 'is-valid': !$v.alamat.$invalid }"
                  placeholder="Alamat"
                  type="text"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="6">
              <label>Jabatan</label>
              <input
                  class="form-control"
                  v-model.trim="$v.jabatan.$model"
                  maxlength="100"
                  :class="{ 'is-invalid':$v.jabatan.$error, 'is-valid': !$v.jabatan.$invalid }"
                  placeholder="Jabatan"
                  type="text"
              />
            </CCol>
            <CCol sm="6">
              <label>Pilih Tipe Role Aplikasi</label>
              <model-select :options="dataRole"
                            class="form-control model-select"
                            v-model.trim="$v.selectedRole.$model"
                            :class="{ 'is-invalid select-invalid':$v.selectedRole.$error, 'is-valid select-valid': !$v.selectedRole.$invalid }"
                            placeholder="Pilih Role">
              </model-select>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="6">
              <label>Tipe Pegawai</label>
              <model-select :options="dataTipePegawai"
                            class="form-control model-select"
                            v-model.trim="$v.tipePegawai.$model"
                            :class="{ 'is-invalid select-invalid':$v.tipePegawai.$error, 'is-valid select-valid': !$v.tipePegawai.$invalid }"
                            placeholder="Pilih Tipe Pegawai">
              </model-select>
            </CCol>
            <CCol sm="6">
              <label>Tanggal Mulai Aktif Kehadiran</label>
              <input
                  class="form-control"
                  v-model.trim="$v.tglAKtif.$model"
                  :class="{ 'is-invalid':$v.tglAKtif.$error, 'is-valid': !$v.tglAKtif.$invalid }"
                  type="date"
              />
            </CCol>
          </CRow>
          <CRow v-if="tipePegawai.pegawai == 'Y' || tipePegawai.pjtk == 'Y'">
            <CCol sm="6" v-if="tipePegawai.pegawai == 'Y'">
              <label>Jenjang Jabatan</label>
              <model-select :options="dataJenjang"
                            class="form-control model-select"
                            v-model="jenjang"
                            placeholder="Pilih Jenjang Jabatan">
              </model-select>
            </CCol>
            <CCol v-if="tipePegawai.pjtk == 'Y'" sm="6">
              <label>Penyedia Jasa Tenaga Kerja (PJTK)</label>
              <model-select :options="dataPJTK"
                            class="form-control model-select"
                            v-model="pjtk"
                            placeholder="Pilih PJTK">
              </model-select>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="6">
              <label>GPS Tracking (Fitur ini akan men-Tracking pegawai secara periodik)</label>
              <model-select :options="dataWajibGPS"
                            class="form-control model-select"
                            v-model.trim="$v.wajibGPS.$model"
                            :class="{ 'is-invalid select-invalid':$v.wajibGPS.$error, 'is-valid select-valid': !$v.wajibGPS.$invalid }"
                            placeholder="Pilih Wajib GPS">
              </model-select>
            </CCol>
            <CCol sm="6">
              <label>Hide WFH</label>
              <model-select :options="dataHideWFH"
                            class="form-control model-select"
                            v-model.trim="$v.hideWFH.$model"
                            :class="{ 'is-invalid select-invalid':$v.hideWFH.$error, 'is-valid select-valid': !$v.hideWFH.$invalid }"
                            placeholder="Pilih Hide WFH">
              </model-select>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="6">
              <label>Unit Level</label>
              <div class="autocomplete">
                <input type="text"
                       class="form-control"
                       @click="toggleVisibleUnit()"
                       @blur="toggleCloseVisibleUnit()"
                       v-text="selectedItemUnit ? selectedItemUnit['text'] : ''"
                       :class="{ 'is-invalid':$v.queryUnit.$error, 'is-valid': !$v.queryUnit.$invalid }"
                       v-model.trim="$v.queryUnit.$model"
                       @keydown.up="upUnit"
                       @keydown.down="downUnit"
                       @keydown.enter="selectItemUnit"
                       placeholder="Pilih Unit Level"
                >
                <div class="popovers" v-show="visibleUnit">
                  <div class="options" v-if="matchesUnit.length != 0 && queryUnit.length != 0" ref="optionsList">
                    <ul>
                      <li v-for="(match, index) in matchesUnit"
                          :key="index"
                          :class="{ 'selected': (selectedUnit == index)}"
                          @click="itemClickedUnit(index)"
                          v-text="match['text']"></li>
                    </ul>
                  </div>
                  <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length != 0">
                    Data Tidak Ditemukan
                  </div>
                  <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length == 0">
                    Start Typing...
                  </div>
                </div>
              </div>
            </CCol>
            <CCol sm="6">
              <label>Pola Absensi</label>
              <model-select :options="dataPolaAbsensi"
                            class="form-control model-select"
                            v-model.trim="$v.polaAbsensi.$model"
                            :class="{ 'is-invalid select-invalid':$v.polaAbsensi.$error, 'is-valid select-valid': !$v.polaAbsensi.$invalid }"
                            placeholder="Pilih Pola Absensi">
              </model-select>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="6">
              <label>Jumlah Device</label>
              <input
                  class="form-control"
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                  v-model.trim="$v.device.$model"
                  :class="{ 'is-invalid':$v.device.$error, 'is-valid': !$v.device.$invalid }"
                  placeholder="Jumlah Device"
                  type="text"
              />
            </CCol>
            <CCol sm="6" v-if="polaAbsensi.value == '1'">
              <label>Kode Absensi</label>
              <model-select :options="dataNormalOrShift"
                            class="form-control model-select"
                            v-model="kodePolaAbsensi"
                            placeholder="Pilih Kode Absensi">
              </model-select>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="6">
              <label>Sync Offline</label>
              <model-select :options="dataSync"
                            class="form-control model-select"
                            v-model="sync"
                            placeholder="Pilih Sync Offline">
              </model-select>
            </CCol>
            <!-- <CCol sm="6" v-if="polaAbsensi.value == '2'">
                <label>Shift Ke-</label>
                <model-select :options="dataShiftKe"
                    class="form-control model-select"
                    v-model="shiftAktif"
                    placeholder="Pilih Shift Ke-">
                </model-select>
            </CCol> -->
          </CRow>
          <CRow style="margin-bottom:48px">
            <CCol sm="6">
              <label>Image Profile</label>
              <div v-if="urlImage == '' || urlImage == 'null'">
                <input v-on:change="onFileChange" style="position:absolute;opacity:0;z-index:1;cursor:pointer"
                       type="file" class="mr-2" accept=".jpg, .png, .bmp"/>
                <div class="cards-image">+</div>
              </div>
              <div v-else>
                <img :src="urlImage" width="56" height="56"/>
                <button @click="removeImage()" class="ml-3 btn btn-danger" size="sm">Delete</button>
              </div>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
      <CRow class="area-button-submit">
        <CCol sm="12">
          <CButton @click="submitForm('non-active')" v-if="aktif == 'Y'" style="float:left;font-size: 14px;width:200px"
                   class="btn btn-danger mr-2">
            <span>Non Active Account</span>
          </CButton>
          <CButton @click="submitForm('active')" v-if="aktif == 'T'" style="float:left;font-size: 14px;width:200px"
                   class="btn btn-success mr-2">
            <span>Active Account</span>
          </CButton>
          <CButton :disabled="loading == true" @click="submitForm('submit')" class="btn btn-edit-submit">
            <span v-if="loading == false">Submit</span>
            <CSpinner v-else color="default" size="sm"/>
          </CButton>
        </CCol>
      </CRow>
    </div>
  </div>
</template>

<script>
import Tables from '../../../component/tables'
import {DataApi, DataApiUpload} from "../../../service/DataApi"
import {ModelSelect} from 'vue-search-select'
import {email, maxLength, required} from 'vuelidate/lib/validators'
import {validationMixin} from 'vuelidate'

const xlsx = require('json-as-xlsx')

export default {
  components: {
    Tables,
    ModelSelect
  },
  mixins: [validationMixin],
  validations: {
    namaPegawai: {
      required,
    },
    nik: {
      required,
    },
    email: {
      required,
      email,
      maxLength: maxLength(50)
    },
    emailValidasi: {
      required: (function () {
        if (this.emailValidasi.length != 0) {
          if (this.emailValidasi == this.email) {
            return true
          } else {
            return false
          }
        } else {
          return ''
        }
      })
    },
    sex: {
      value: {
        required
      },
      text: {
        required
      }
    },
    queryUnit: {
      required
    },
    tipePegawai: {
      value: {
        required
      },
      text: {
        required
      },
      pjtk: {
        required
      }
    },
    wajibGPS: {
      value: {
        required
      },
      text: {
        required
      }
    },
    hideWFH: {
      value: {
        required
      },
      text: {
        required
      }
    },
    selectedRole: {
      value: {
        required
      },
      text: {
        required
      }
    },
    usernameBy: {
      value: {
        required
      },
      text: {
        required
      }
    },
    polaAbsensi: {
      value: {
        required
      },
      text: {
        required
      }
    },
    // sync: {
    //     value: {
    //         required
    //     },
    //     text: {
    //         required
    //     }
    // },
    jabatan: {
      required,
    },
    alamat: {
      required,
    },
    telp: {
      required,
    },
    device: {
      required,
    },
    tglAKtif: {
      required,
    },
  },
  data() {
    return {
      success: true,
      itemHeight: 39,

      dataStatus: [],
      filterStatus: {
        value: '',
        text: ''
      },

      // data search unit
      dataUnit: [],
      titleUnit: "Pilih Unit Level",
      selectedItemUnit: null,
      selectedUnit: 0,
      queryUnit: '',
      visibleUnit: false,
      idUnit: '',

      // data search unit search
      dataUnitSearch: [],
      titleUnitSearch: "Pilih Unit Level",
      selectedItemUnitSearch: null,
      selectedUnitSearch: 0,
      queryUnitSearch: '',
      visibleUnitSearch: false,
      idUnitSearch: '',

      refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
      downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
      moreIcon: require('../../../assets/menu/icon_more.svg'),
      backIcon: require('../../../assets/menu/icon_goback.svg'),
      dataTh: ['Nama Pegawai', 'NIP', 'Tipe', 'Email', 'Jenis Kelamin', 'Divisi', 'Jabatan', 'Action'],
      dataTd: [['urlFoto', 'nama'], 'nik', 'keteranganTipePegawai', 'email', 'sex', 'bidang', 'jabatan', 'action'],
      styleTable: ['200px', '100px', '100px', '100px', '130px', '100px', '100px', '100px'],
      classReload: 'reloadOff',
      goArea: true,
      loading: false,
      alertMess: '',
      currentAlertCounter: 0,

      // data model
      namaPegawai: '',
      nik: '',
      email: '',
      emailValidasi: '',
      dataSex: [],
      sex: {
        value: '',
        text: ''
      },
      dataTipePegawai: [],
      tipePegawai: {
        value: '',
        text: '',
        pjtk: ''
      },
      dataUnitLevel: [],
      bidang: '',
      jabatan: '',
      alamat: '',
      telp: '',
      device: '',
      username: '',
      dataUsernameBy: [],
      usernameBy: {
        value: '',
        text: ''
      },
      dataNormalOrShift: [],
      kodePolaAbsensi: {
        value: '',
        text: ''
      },
      dataWajibGPS: [],
      wajibGPS: {
        value: '',
        text: ''
      },
      dataHideWFH: [],
      hideWFH: {
        value: '',
        text: ''
      },
      dataPJTK: [],
      pjtk: {
        value: '',
        text: ''
      },

      urlImage: '',
      showImage: '',
      urlPath: '',
      tipe: 'C',
      id: 0,
      aktif: "",
      gpsInterval: 0,
      lvl: '',
      organisasi: '',
      dataPolaAbsensi: [],
      polaAbsensi: {
        text: '',
        value: ''
      },
      jenjang: {
        value: '',
        text: ''
      },
      dataJenjang: [],
      radius: 0,
      fullDataShift: [],
      dataShiftKe: [],
      shiftAktif: {
        value: '',
        text: ''
      },
      dataRole: [],
      selectedRole: {
        value: '',
        text: ''
      },
      dataSync: [],
      sync: {
        value: '2',
        text: 'No'
      },
      tglAKtif: '',

      // paging
      page: 1,
      size: 20,
      totalRow: 0,
      totalPage: 1,
      firstPage: 0,
      lastPage: 0,

      // filter
      searchValue: '',
      searchDivision: '',
      searchJobPosition: '',

      // datas
      datas: [],

      // error
      errorMessage: '',

      flagSearch: false,
    }
  },
  computed: {
    matchesUnit() {
      if (this.queryUnit == '') {
        return [];
      }
      return this.dataUnit.filter((item) => item['text'].toLowerCase().includes(this.queryUnit.toLowerCase()))
    },
    matchesUnitSearch() {
      if (this.queryUnitSearch == '') {
        return [];
      }
      return this.dataUnitSearch.filter((item) => item['text'].toLowerCase().includes(this.queryUnitSearch.toLowerCase()))
    },
  },
  watch: {
    page() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    searchValue() {
      this.flagSearch = true
    },
    searchJobPosition() {
      this.flagSearch = true
    },
    queryUnit() {
      if (this.queryUnit == '') {
        this.idUnit = ''
      }
      this.getDataUnit('null')
    },
    queryUnitSearch() {
      this.flagSearch = true
      this.getDataUnitSearch()
    },
    filterStatus() {
      this.flagSearch = true
    },
    polaAbsensi() {
      this.kodePolaAbsensi.value = ''
      this.kodePolaAbsensi.text = ''
      this.getNormalOrShift()
    },
    kodePolaAbsensi() {
      this.shiftAktif.value = ''
      this.shiftAktif.text = ''
      this.getDataShiftKe()
    },
    goArea() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    tipePegawai() {
      if (this.tipePegawai.pjtk == 'Y') {
      } else {
        this.pjtk.value = ''
        this.pjtk.text = ''
        this.getDataPJTK()
      }
      if (this.tipePegawai.pegawai == 'Y') {
        //
      } else {
        this.jenjang.value = ''
        this.jenjang.text = ''
        this.getDataJenjang()
      }
    }

  },
  methods: {
    goSyncEmp() {
      this.loading = true
      DataApi.post("pegawai/sync_pegawai")
          .then(res => {
            let response = res.data
            this.success = response.success
            this.alertMess = response.message
            this.loading = false
            this.currentAlertCounter = 7
          })
    },
    /**
     * SEARCH UNIT LEVEL
     */
    getDataUnit(val) {
      let payload = ''
      if (val == 'null') {
        payload = {
          limit: 10,
          namaUnit: this.queryUnit,
          pageIn: 1,
          namaParentUnit: '',
          idUnit: ''
        }
      } else {
        payload = {
          limit: 10,
          namaUnit: '',
          pageIn: 1,
          namaParentUnit: '',
          idUnit: val
        }
      }
      DataApi.post("unit/get", payload)
          .then(res => {
            this.dataUnit = []
            let response = res.data.data
            let tempData = response.data
            var i = 0;
            for (i = 0; i < tempData.length; i++) {
              let onPush = ''
              if (tempData[i].parentBidang == null || tempData[i].parentBidang == 'null') {
                onPush = {
                  value: tempData[i].id,
                  text: tempData[i].bidang
                }
              } else {
                onPush = {
                  value: tempData[i].id,
                  text: tempData[i].bidang + ' - ' + tempData[i].parentBidang
                }
              }
              this.dataUnit.push(onPush)
            }
            if (val != 'null') {
              this.idUnit = val
              this.queryUnit = this.dataUnit[0].text
            }
          })
    },
    toggleVisibleUnit() {
      this.visibleUnit = true;
    },
    hideUnit() {
      this.visibleUnit = false;
    },
    toggleCloseVisibleUnit() {
      setTimeout(this.hideUnit, 1000);
    },
    itemClickedUnit(index) {
      this.selectedUnit = index;
      this.selectItemUnit();
    },
    selectItemUnit() {
      if (!this.matchesUnit.length) {
        return;
      }
      this.selectedItemUnit = this.matchesUnit[this.selectedUnit];
      this.queryUnit = this.selectedItemUnit.text
      this.idUnit = this.selectedItemUnit.value
      this.visibleUnit = false;
      if (this.shouldReset) {
        this.queryUnit = '';
        this.selectedUnit = 0;
      }
    },
    upUnit() {
      if (this.selectedUnit == 0) {
        return;
      }
      this.selectedUnit -= 1;
      this.scrollToItemUnit();
    },
    downUnit() {
      if (this.selectedUnit >= this.matchesUnit.length - 1) {
        return;
      }
      this.selectedUnit += 1;
      this.scrollToItemUnit();
    },
    scrollToItemUnit() {
      this.$refs.optionsList.scrollTop = this.selectedUnit * this.itemHeight;
    },

    /**
     * GET DATA
     */
    sorting(value) {
      if (value == 0) {
        function compare(a, b) {
          if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
            return -1
          }
          if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
            return 1
          }
          return 0
        }

        return this.datas.sort(compare)
      } else if (value == 1) {
        function compare(a, b) {
          if (a.nik.toLowerCase() < b.nik.toLowerCase()) {
            return -1
          }
          if (a.nik.toLowerCase() > b.nik.toLowerCase()) {
            return 1
          }
          return 0
        }

        return this.datas.sort(compare)
      } else if (value == 2) {
        function compare(a, b) {
          if (a.email.toLowerCase() < b.email.toLowerCase()) {
            return -1
          }
          if (a.email.toLowerCase() > b.email.toLowerCase()) {
            return 1
          }
          return 0
        }

        return this.datas.sort(compare)
      } else if (value == 3) {
        function compare(a, b) {
          if (a.sex.toLowerCase() < b.sex.toLowerCase()) {
            return -1
          }
          if (a.sex.toLowerCase() > b.sex.toLowerCase()) {
            return 1
          }
          return 0
        }

        return this.datas.sort(compare)
      } else if (value == 4) {
        function compare(a, b) {
          if (a.bidang.toLowerCase() < b.bidang.toLowerCase()) {
            return -1
          }
          if (a.bidang.toLowerCase() > b.bidang.toLowerCase()) {
            return 1
          }
          return 0
        }

        return this.datas.sort(compare)
      } else if (value == 5) {
        function compare(a, b) {
          if (a.jabatan.toLowerCase() < b.jabatan.toLowerCase()) {
            return -1
          }
          if (a.jabatan.toLowerCase() > b.jabatan.toLowerCase()) {
            return 1
          }
          return 0
        }

        return this.datas.sort(compare)
      }
    },
    getData() {
      if (this.flagSearch == true) {
        this.page = 1
      }
      this.$store.state.loadingScreen = true
      let limit = this.size
      let nama = this.searchValue
      let page = this.page
      let bidang = this.idUnitSearch
      let jabatan = this.searchJobPosition
      let pegawaiId = ''
      let aktif = this.filterStatus.value

      let payload = {
        limit: limit,
        nama: nama,
        pageIn: page,
        bidang: bidang,
        jabatan: jabatan,
        pegawaiId: pegawaiId,
        tipePegawai: '',
        aktif: aktif
      }
      DataApi.post("pegawai/get", payload)
          .then(res => {
            let response = res.data
            if (response.success == true) {
              this.datas = response.data.data
              this.totalRow = response.data.totalRow
              this.firstPage = (((this.page - 1) * this.size) + 1)
              this.lastPage = (((this.page - 1) * this.size) + this.datas.length)
              this.totalPage = Math.floor(this.totalRow / this.size)
              let modAr = this.totalRow % this.size
              if (modAr != 0) {
                this.totalPage = this.totalPage + 1
              } else {
                //
              }
            } else {
              this.datas = []
              this.totalRow = 0
              this.firstPage = 0
              this.lastPage = 0
              this.totalPage = 1
              this.errorMessage = response.message
            }
            this.flagSearch = false
            this.$store.state.loadingScreen = false
          })
    },
    getDownload() {
      this.$store.state.loadingScreen = true
      let limit = this.totalRow
      let nama = this.searchValue
      let page = 1
      let bidang = this.idUnitSearch
      let jabatan = this.searchJobPosition
      let pegawaiId = ''
      let aktif = this.filterStatus.value

      let payload = {
        limit: limit,
        nama: nama,
        pageIn: page,
        bidang: bidang,
        jabatan: jabatan,
        pegawaiId: pegawaiId,
        tipePegawai: '',
        aktif: aktif
      }
      DataApi.post("pegawai/get", payload)
          .then(res => {
            let response = res.data
            if (response.success == true) {
              let downloads = response.data.data
              let data = [
                {
                  sheet: 'Data Pegawai',
                  columns: [
                    {label: 'Nama', value: 'nama'},
                    {label: 'NIP', value: 'nik'},
                    {label: 'Email', value: 'email'},
                    {label: 'Jabatan', value: 'jabatan'},
                    {label: 'Jenjang Jabatan', value: 'jenjangJabatan'},
                    {label: 'Bidang', value: 'bidang'},
                    {label: 'Tipe Pegawai', value: 'keteranganTipePegawai'},
                    {label: 'Telepon', value: 'telepon'},
                    {label: 'Alamat', value: 'alamat'},
                    {label: 'Jenis Kelamin', value: 'sex'},
                    {label: 'Nama Atasan', value: 'namaAtasan'},
                    {label: 'Tipe Absen', value: 'shift'},
                    {label: 'Status', value: 'aktif'},
                    {label: 'Kuota Cuti', value: 'kuotaCuti'},
                    {label: 'Cuti yang dipakai', value: 'cutiPakai'},
                    {label: 'Sisa Cuti', value: 'sisaCuti'},

                  ],
                  content: downloads
                }
              ]
              let settings = {
                fileName: 'Data Pegawai'
              }
              xlsx(data, settings)
            }
            this.$store.state.loadingScreen = false
          })
    },
    getDataNormal() {
      this.dataNormalOrShift = []
      let payload = {
        limit: 9999,
        kode: '',
        pageIn: 1,
      }
      DataApi.post("jam_kerja/lihat", payload)
          .then(res => {
            let response = res.data.data
            let tempData = response.data
            let data = []
            var i = 0;
            for (i = 0; i < tempData.length; i++) {
              let onPush = {
                value: tempData[i].kode,
                text: tempData[i].kode + ' - ' + tempData[i].deskripsi
              }
              data.push(onPush)
            }
            let filter = []
            var j
            for (j = 0; j < data.length; j++) {
              if (filter.length == 0) {
                let inPush = {
                  value: data[j].value,
                  text: data[j].text
                }
                filter.push(inPush)
              } else {
                var k
                let status = false
                for (k = 0; k < filter.length; k++) {
                  if (data[j].value == filter[k].value) {
                    status = true
                    break
                  } else {
                    status = false
                  }
                }
                if (status == false) {
                  let inPush = {
                    value: data[j].value,
                    text: data[j].text
                  }
                  filter.push(inPush)
                }
              }
            }
            this.dataNormalOrShift = filter
          })
    },
    getDataShift() {
      this.dataNormalOrShift = []
      let payload = {
        limit: 9999,
        kodeShift: '',
        deskripsi: '',
        pageIn: 1,
      }
      DataApi.post("shift/lihat", payload)
          .then(res => {
            let response = res.data.data
            let tempData = response.data
            this.fullDataShift = tempData
            if (this.tipe == 'u' || this.tipe == 'U') {
              this.getDataShiftKe()
            }
            var i = 0;
            for (i = 0; i < tempData.length; i++) {
              let onPush = {
                value: tempData[i].kode,
                text: tempData[i].kode + ' - ' + tempData[i].deskripsi
              }
              this.dataNormalOrShift.push(onPush)
            }
          })
    },
    getNormalOrShift() {
      if (this.polaAbsensi.value != '') {
        if (this.polaAbsensi.value == '1') {
          this.getDataNormal()
          this.shiftAktif.value = ''
          this.shiftAktif.text = ''
        } else {
          this.getDataShift()
        }
      }
    },
    getDataPolaAbsensi() {
      this.dataPolaAbsensi = [
        {text: 'Normal', value: '1'},
        {text: 'Shift', value: '2'}
      ]
    },
    getDataUsernameBy() {
      this.dataUsernameBy = [
        {text: 'LDAP', value: '1'},
        {text: 'Google', value: '2'}
      ]
    },
    getDataSex() {
      this.dataSex = [
        {text: 'LAKI-LAKI', value: 1},
        {text: 'PEREMPUAN', value: 2}
      ]
    },
    getDataShiftKe() {
      this.dataShiftKe = []
      if (this.polaAbsensi.text == 'Shift') {
        var i = 0
        for (i = 0; i < this.fullDataShift.length; i++) {
          if (this.kodePolaAbsensi.value == this.fullDataShift[i].kode) {
            let shift1 = parseInt(this.fullDataShift[i].shift1Hari)
            let shift2 = parseInt(this.fullDataShift[i].shift2Hari)
            let shift3 = parseInt(this.fullDataShift[i].shift3Hari)
            let shift4 = parseInt(this.fullDataShift[i].shift4Hari)
            let totalShift = shift1 + shift2 + shift3 + shift4
            var j = 0
            this.dataShiftKe = []
            for (j = 0; j < totalShift; j++) {
              let push = {
                text: (j + 1).toString(),
                value: j + 1
              }
              this.dataShiftKe.push(push)
            }
          }
        }
      }
    },
    getDataTipePegawai() {
      let payload = {
        keterangan: '',
        limit: 9999,
        pageIn: 1
      }
      DataApi.post("pegawai/status/lihat", payload)
          .then(res => {
            this.dataTipePegawai = []
            let response = res.data.data.data
            var i = 0
            for (i = 0; i < response.length; i++) {
              let onPush = {
                value: response[i].kode,
                text: response[i].keterangan,
                pjtk: response[i].pjtk,
                pegawai: response[i].pegawai
              }
              this.dataTipePegawai.push(onPush)
            }
          })
    },
    getDataRole() {
      let limit = 9999
      let page = 1
      let nama = ''

      let payload = {
        limit: limit,
        pageIn: page,
        nama: nama,
      }
      DataApi.post("menu/role/get", payload)
          .then(res => {
            let response = res.data
            if (response.success == true) {
              let tempDataRole = response.data.data
              this.pharsRole(tempDataRole)
            } else {
              this.datas = []
              this.errorMessage = response.message
            }
          })
    },
    getDataWajibGPS() {
      this.dataWajibGPS = [
        {value: 'Y', text: 'Yes'},
        {value: 'T', text: 'No'}
      ]
      this.wajibGPS.value = 'T'
      this.wajibGPS.text = 'No'
    },
    getDataHideWFH() {
      this.dataHideWFH = [
        {value: 'Y', text: 'Yes'},
        {value: 'T', text: 'No'}
      ]
      this.hideWFH.value = 'T'
      this.hideWFH.text = 'No'
    },
    pharsRole(data) {
      this.dataRole = []
      var i = 0
      for (i = 0; i < data.length; i++) {
        let onPush = {
          value: data[i].idRole,
          text: data[i].namaRole
        }
        this.dataRole.push(onPush)
      }
    },
    getDataStatus() {
      this.dataStatus = [
        {value: 'Y', text: 'Active'},
        {value: 'T', text: 'Non Active'}
      ]
    },
    getDataPJTK() {
      let limit = 9999
      let page = 1
      let nama = ''

      let payload = {
        limit: 9999,
        namaOrganisasi: "",
        organisasi: "",
        pageIn: page,
        pjtk: 'Y'
      }
      DataApi.post("perusahaan/get", payload)
          .then(res => {
            this.dataPJTK = []
            let response = res.data
            if (response.success == true) {
              let temp = response.data.data
              var i
              for (i = 0; i < temp.length; i++) {
                let push = {
                  text: temp[i].nama,
                  value: temp[i].kode
                }
                this.dataPJTK.push(push)
              }
            }
          })
    },
    findData() {
      this.getData()
    },
    movePage(direction) {
      if (direction == 'prev') {
        this.page = this.page - 1
      } else {
        this.page = this.page + 1
      }
      this.getData()
    },
    validatePage(page) {
      if (page > this.totalPage) {
        this.page = this.totalPage
      }
    },
    reload() {
      this.searchValue = ''
      this.idUnitSearch = ''
      this.queryUnitSearch = ''
      this.searchJobPosition = ''
      this.filterStatus.text = ''
      this.filterStatus.value = ''
      this.flagSearch = true
      this.getData()
      this.getDataStatus()
      if (this.classReload == 'reloadOff') {
        this.classReload = 'reloadOn'
      } else {
        this.classReload = 'reloadOff'
      }
    },

    /**
     * ADD DATA
     */
    moving() {
      setTimeout(this.moveArea, 600);
    },
    moveArea() {
      if (this.goArea == true) {
        this.goArea = false
      } else {
        this.goArea = true
        this.namaPegawai = ''
        this.nik = ''
        this.email = ''
        this.emailValidasi = ''
        this.sex.value = ''
        this.sex.text = ''
        this.jabatan = ''
        this.alamat = ''
        this.telp = ''
        this.device = ''
        this.username = ''
        this.usernameBy.value = ''
        this.usernameBy.text = ''
        this.tipePegawai.value = ''
        this.tipePegawai.text = ''
        this.tipePegawai.pjtk = ''
        this.shiftAktif.text = ''
        this.shiftAktif.value = ''
        this.jenjang.text = ''
        this.jenjang.value = ''
        this.kodePolaAbsensi.value = ''
        this.kodePolaAbsensi.text = ''
        this.selectedRole.value = ''
        this.selectedRole.text = ''
        this.urlImage = ''
        this.showImage = ''
        this.urlPath = ''
        this.tipe = 'C'
        this.tglAKtif = ''
        this.aktif = ''
        this.dataNormalOrShift = []
        this.id = 0
        this.idUnit = 0
        this.queryUnit = ''
        this.polaAbsensi.text = ''
        this.polaAbsensi.value = ''
        this.sync.text = 'No'
        this.sync.value = '2'
        this.pjtk.value = ''
        this.pjtk.text = ''
        this.getDataUnit('null')
        this.getDataPolaAbsensi()
        this.getDataSex()
        this.getDataUsernameBy()
        this.getDataTipePegawai()
        this.getDataRole()
        this.getDataWajibGPS()
        this.getDataHideWFH()
        this.getDataPJTK()
        this.getDataJenjang()
        this.getDataSync()
        this.$v.$reset()
      }
    },
    goSave(val) {
      let namaPegawai = this.namaPegawai
      let nik = this.nik
      let email = this.email
      let emailValidasi = this.emailValidasi
      let sex = this.sex.value
      let bidang = this.queryUnit.split(" - ")[0]
      let jabatan = this.jabatan
      let alamat = this.alamat
      let telp = this.telp
      let device = this.device
      let username = ''
      if (this.tipe == 'C') {
        username = this.email
      } else {
        username = this.email.split("@")[0]
      }
      let usernameBy = this.usernameBy.value
      let urlImage = this.urlPath
      let tipe = this.tipe
      let idPegawai = this.id
      let aktif = ''
      if (val != 'submit') {
        if (this.aktif == 'Y') {
          aktif = 'T'
        } else {
          aktif = 'Y'
        }
      } else {
        aktif = 'Y'
      }

      let kodePolaAbsensi = this.kodePolaAbsensi.value
      let lvl = this.idUnit
      let polaAbsensi = this.polaAbsensi.value
      let radius = this.radius
      let shiftAktif = ''
      let idRole = this.selectedRole.value
      if (this.polaAbsensi.value == '1') {
        shiftAktif = 0
      } else {
        shiftAktif = this.shiftAktif.value
      }
      let tglAktif = new Date(this.tglAKtif).toJSON()
      let wajibGps = this.wajibGPS.value

      let gpsInterval = ''
      if (this.wajibGPS.value == 'Y') {
        gpsInterval = '15'
      } else {
        gpsInterval = '0'
      }
      let hideWfh = this.hideWFH.value
      let tipePegawai = this.tipePegawai.value
      let pjtk = this.pjtk.value
      let jenjang = this.jenjang.value
      let sync = this.sync.value

      let payload = {
        aktif: aktif,
        alamat: alamat,
        bidang: bidang,
        email: email,
        gpsInterval: gpsInterval,
        hideWfh: hideWfh,
        idPegawai: idPegawai,
        jabatan: jabatan,
        jenjangJabatan: jenjang,
        jumlahDevice: device,
        kelamin: sex,
        kodePolaAbsensi: kodePolaAbsensi,
        lvl: lvl,
        nama: namaPegawai,
        nik: nik,
        photoManual: urlImage,
        polaAbsensi: polaAbsensi,
        radius: radius,
        tipePegawai: tipePegawai,
        pjtk: pjtk,
        shifAktif: shiftAktif,
        syncOffline: sync,
        telepon: telp,
        tglAKtif: tglAktif,
        tipe: tipe,
        username: username,
        usernameBy: usernameBy,
        validasiEmail: emailValidasi,
        wajibGps: wajibGps,
        idRole: idRole
      }
      DataApi.post("pegawai/save", payload)
          .then(res => {
            let response = res.data
            if (response.success == true) {
              if (response.data.Data1 == 'Y') {
                this.success = true
              } else {
                this.success = false
              }
              this.alertMess = response.data.Data2
            } else {
              this.alertMess = response.message
              this.success = false
            }
            this.getData()
            this.moving()
            this.loading = false
            this.currentAlertCounter = 7
          })
    },

    /**
     * EDIT DATA
     */
    editData(value) {
      let limit = 1
      let nama = ""
      let page = 1
      let bidang = ""
      let jabatan = ""
      let pegawaiId = this.datas[value].idPegawai
      let aktif = ""

      let payload = {
        limit: limit,
        nama: nama,
        pageIn: page,
        bidang: bidang,
        jabatan: jabatan,
        pegawaiId: pegawaiId,
        tipePegawai: "",
        aktif: aktif
      }
      DataApi.post("pegawai/get", payload)
          .then(res => {
            let response = res.data
            if (response.success == true) {
              let data = response.data.data
              this.namaPegawai = data[0].nama
              this.nik = data[0].nik
              this.email = data[0].email
              this.emailValidasi = data[0].validasiEmail
              this.id = parseInt(data[0].idPegawai)
              this.jabatan = data[0].jabatan
              this.alamat = data[0].alamat
              this.telp = data[0].telepon
              this.device = data[0].jumlahDevice
              this.username = data[0].userName
              let kelamin = data[0].sex.toLowerCase()
              if (
                  kelamin == 'man' ||
                  kelamin == 'pria' ||
                  kelamin == 'laki-laki' ||
                  kelamin == 'cowok'
              ) {
                this.sex.value = 1
                this.sex.text = 'LAKI-LAKI'
              } else {
                this.sex.value = 2
                this.sex.text = 'PEREMPUAN'
              }

              this.getDataUnit(data[0].lvl)
              let dataRole = this.dataRole
              let tempRole = data[0].idRole

              var j = 0

              for (let j = 0; j < dataRole.length; j++) {
                if (tempRole == dataRole[j].value) {
                  this.selectedRole.text = dataRole[j].text
                  this.selectedRole.value = dataRole[j].value
                }
              }

              if (data[0].shift.toLowerCase() == 'normal') {
                this.polaAbsensi.text = 'Normal'
                this.polaAbsensi.value = '1'
              } else {
                this.polaAbsensi.text = 'Shift'
                this.polaAbsensi.value = '2'
              }
              this.getNormalOrShift()

              if (data[0].urlFoto == 'null' ||
                  data[0].urlFoto == null ||
                  data[0].urlFoto == '' ||
                  data[0].urlFoto == undefined) {
                this.urlImage = 'null'
              } else {
                this.urlImage = data[0].urlFoto
              }

              if (data[0].usernameBy == '1') {
                this.usernameBy.text = 'LDAP'
                this.usernameBy.value = '1'
              } else if (data[0].usernameBy == '2') {
                this.usernameBy.text = 'Google'
                this.usernameBy.value = '2'
              } else if (data[0].usernameBy == '3') {
                this.usernameBy.text = ''
                this.usernameBy.value = ''
              } else if (data[0].usernameBy == '4') {
                this.usernameBy.text = ''
                this.usernameBy.value = ''
              } else if (data[0].usernameBy == '') {
                this.usernameBy.text = ''
                this.usernameBy.value = ''
              }
              this.kodePolaAbsensi.value = data[0].kodePolaAbsensi
              this.kodePolaAbsensi.text = data[0].kodePolaAbsensi

              let dataWajibGPS = this.dataWajibGPS
              var w = 0
              for (w = 0; w < dataWajibGPS.length; w++) {
                if (data[0].wajibGPS == dataWajibGPS[w].value) {
                  this.wajibGPS.value = dataWajibGPS[w].value
                  this.wajibGPS.text = dataWajibGPS[w].text
                  break
                } else {
                  this.wajibGPS.value = ''
                  this.wajibGPS.text = ''
                }
              }
              let hideWFH = this.dataHideWFH
              var h = 0
              for (h = 0; h < hideWFH.length; h++) {
                if (data[0].hideWFH == hideWFH[h].value) {
                  this.hideWFH.value = hideWFH[h].value
                  this.hideWFH.text = hideWFH[h].text
                  break
                } else {
                  this.hideWFH.value = ''
                  this.hideWFH.text = ''
                }
              }


              let dataTipePegawai = this.dataTipePegawai
              var tipe = 0
              for (tipe = 0; tipe < dataTipePegawai.length; tipe++) {
                if (data[0].tipePegawai == dataTipePegawai[tipe].value) {
                  this.tipePegawai.value = dataTipePegawai[tipe].value
                  this.tipePegawai.text = dataTipePegawai[tipe].text
                  this.tipePegawai.pjtk = dataTipePegawai[tipe].pjtk
                  this.tipePegawai.pegawai = dataTipePegawai[tipe].pegawai
                }
              }

              this.aktif = data[0].aktif

              this.shiftAktif.value = parseInt(data[0].shiftAktif)
              this.shiftAktif.text = data[0].shiftAktif
              if (data[0].tglAktif == 'null' || data[0].tglAktif == '') {
                this.tglAKtif = ''
              } else {
                this.tglAKtif = data[0].tglAktif.split(" ")[0]
              }

              let dataPJTK = this.dataPJTK
              let pjtk = data[0].pjtk
              var pj = 0
              for (pj = 0; pj < dataPJTK.length; pj++) {
                if (dataPJTK[pj].value == pjtk) {
                  this.pjtk.value = dataPJTK[pj].value
                  this.pjtk.text = dataPJTK[pj].text
                }
              }
              let dataJenjang = this.dataJenjang
              let jenjang = data[0].jenjangJabatan
              var jn = 0
              for (jn = 0; jn < dataJenjang.length; jn++) {
                if (dataJenjang[jn].value == jenjang) {
                  this.jenjang.value = dataJenjang[jn].value
                  this.jenjang.text = dataJenjang[jn].text
                }
              }
              if (data[0].syncOffline == '1') {
                this.sync.value = '1'
                this.sync.text = 'Yes'
              } else {
                this.sync.value = '2'
                this.sync.text = 'No'
              }
              this.tipe = 'U'
              this.moving()
            }
          })
    },

    /**
     * IMAGE
     */
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.showImage = files[0];
      this.createImage(files[0]);
    },
    createImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.urlImage = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    saveImage(val) {
      if (this.urlImage.split(":")[0] == 'data' && this.urlImage != '') {
        let imageData = this.showImage
        let idPegawaiData = 0
        let inOutData = "1"
        let kodePerusahaanData = this.organisasi
        let tanggalData = new Date()
        let lvlData = this.lvl

        const fd = new FormData()
        fd.append('file', imageData)
        fd.append('idPegawai', idPegawaiData)
        fd.append('inOut', inOutData)
        fd.append('kodePerusahaan', kodePerusahaanData)
        fd.append('tanggal', tanggalData)
        fd.append('lvl', lvlData)

        DataApiUpload.post('upload/file', fd)
            .then(res => {
              let response = res.data
              if (response.success == true) {
                this.urlPath = response.data.urlPath
                this.goSave(val)
              } else {
                alert('Upload Photo Failed !')
                this.loading = false
              }
            });
      } else if (this.urlImage == '') {
        this.urlPath = ''
        this.goSave(val)
      } else {
        this.urlPath = this.urlImage
        this.goSave(val)
      }
    },
    removeImage() {
      this.showImage = ''
      this.urlImage = ''
      this.urlPath = ''
    },

    /**
     * VALIDATION
     */
    submitForm(val) {
      this.$v.$touch()
      if (this.$v.$invalid) {
      } else {
        this.saveImage(val)
        if (val == 'submit') {
          this.loading = true
        }
      }
    },
    emailFormatter(value) {
      if (!value) return value;
      let parts = value.split('@');
      if (parts.length !== 2) return value;
      parts[1] = parts[1].toLowerCase();
      return parts.join('@');
    },

    /**
     * SEARCH UNIT LEVEL SEARCH
     */
    getDataUnitSearch() {
      let payload = {
        limit: 10,
        namaUnit: this.queryUnitSearch,
        pageIn: 1,
        namaParentUnit: '',
        idUnit: ''
      }
      DataApi.post("unit/get", payload)
          .then(res => {
            this.dataUnitSearch = []
            let response = res.data.data
            let tempData = response.data
            var i = 0;
            for (i = 0; i < tempData.length; i++) {
              let onPush = ''
              if (tempData[i].parentBidang == null || tempData[i].parentBidang == 'null') {
                onPush = {
                  value: tempData[i].id,
                  text: tempData[i].bidang
                }
              } else {
                onPush = {
                  value: tempData[i].id,
                  text: tempData[i].bidang + ' - ' + tempData[i].parentBidang
                }
              }
              this.dataUnitSearch.push(onPush)
            }
          })
    },
    toggleVisibleUnitSearch() {
      this.visibleUnitSearch = true;
    },
    hideUnitSearch() {
      this.visibleUnitSearch = false;
    },
    toggleCloseVisibleUnitSearch() {
      setTimeout(this.hideUnitSearch, 1000);
    },
    itemClickedUnitSearch(index) {
      this.selectedUnitSearch = index;
      this.selectItemUnitSearch();
    },
    selectItemUnitSearch() {
      if (!this.matchesUnitSearch.length) {
        return;
      }
      this.selectedItemUnitSearch = this.matchesUnitSearch[this.selectedUnitSearch];
      this.queryUnitSearch = this.selectedItemUnitSearch.text
      this.idUnitSearch = this.selectedItemUnitSearch.value
      this.visibleUnitSearch = false;
      if (this.shouldReset) {
        this.queryUnitSearch = '';
        this.selectedUnitSearch = 0;
      }
    },
    upUnitSearch() {
      if (this.selectedUnitSearch == 0) {
        return;
      }
      this.selectedUnitSearch -= 1;
      this.scrollToItemUnitSearch();
    },
    downUnitSearch() {
      if (this.selectedUnitSearch >= this.matchesUnitSearch.length - 1) {
        return;
      }
      this.selectedUnitSearch += 1;
      this.scrollToItemUnitSearch();
    },
    scrollToItemUnitSearch() {
      this.$refs.optionsList.scrollTop = this.selectedUnitSearch * this.itemHeight;
    },
    getDataToken() {
      this.$store.state.loadingScreen = true
      DataApi.get("pegawai/role/cek")
          .then(response => {
            let res = response.data
            if (res.success == true) {
              this.lvl = res.data.lvl
              this.organisasi = res.data.organisasi
            }
            this.$store.state.loadingScreen = false
          })
    },
    getDataJenjang() {
      let payload = {
        jenjang: ''
      }
      DataApi.post("pegawai/jenjang/lihat", payload)
          .then(response => {
            this.dataJenjang = []
            let res = response.data
            if (res.success == true) {
              let data = res.data
              var i
              for (i = 0; i < data.length; i++) {
                let onPush = {
                  value: data[i].jenjang,
                  text: data[i].jenjang
                }
                this.dataJenjang.push(onPush)
              }
            }
          })
    },
    getDataSync() {
      this.dataSync = [
        {value: '1', text: 'Yes'},
        {value: '2', text: 'No'}
      ]
    }
  },
  mounted() {
    this.errorMessage = 'Find Your Data'
    this.getDataToken()
    this.getDataStatus()
    this.getDataUnitSearch()
    this.getDataUnit('null')
    this.getDataPolaAbsensi()
    this.getDataSex()
    this.getDataUsernameBy()
    this.getDataTipePegawai()
    this.getDataRole()
    this.getDataWajibGPS()
    this.getDataHideWFH()
    this.getDataPJTK()
    this.getDataJenjang()
    this.getDataSync()
  },
}
</script>
<style scoped>
.containers {
  background-color: white;
  border-bottom: 1px solid #e5e6e8;
}

@media screen and (min-width: 1253px) and (max-width: 1358px) {
  .inputs-form {
    float: left;
    width: 26%;
    margin-right: 12px;
    background-color: rgba(249, 250, 252, 1);
  }
}

@media screen and (min-width: 1168px) and (max-width: 1252px) {
  .inputs-form {
    float: left;
    width: 25%;
    margin-right: 12px;
    background-color: rgba(249, 250, 252, 1);
  }
}

@media screen and (min-width: 1097px) and (max-width: 1167px) {
  .inputs-form {
    float: left;
    width: 24%;
    margin-right: 12px;
    background-color: rgba(249, 250, 252, 1);
  }
}

@media screen and (min-width: 1036px) and (max-width: 1096px) {
  .inputs-form {
    float: left;
    width: 23%;
    margin-right: 12px;
    background-color: rgba(249, 250, 252, 1);
  }
}

@media screen and (min-width: 992px) and (max-width: 1035px) {
  .inputs-form {
    float: left;
    width: 22%;
    margin-right: 12px;
    background-color: rgba(249, 250, 252, 1);
  }
}

@media screen and (min-width: 1359px) {
  .inputs-form {
    float: left;
    width: 27%;
    margin-right: 12px;
    background-color: rgba(249, 250, 252, 1);
  }
}

.btn-search {
  border-radius: 4px;
  width: 100%;
  background-color: rgba(48, 107, 221, 1);
  color: white;
}

.btn-search:hover {
  border-radius: 4px;
  width: 100%;
  background-color: rgba(48, 107, 255, 1);
  color: white;
}

.btn-add {
  border-radius: 4px;
  width: 100%;
  margin-right: 6px;
  border: 1px solid rgba(48, 107, 221, 1);
  background-color: white;
  color: rgba(16, 16, 16, 1);
  font-weight: 500;
  font-size: 14px;
}

.btn-add:hover {
  border-radius: 4px;
  width: 100%;
  margin-right: 6px;
  border: 1px solid rgba(48, 107, 221, 1);
  background-color: rgba(48, 107, 221, 1);
  color: white;
}

.reloadOn {
  float: left;
  cursor: pointer;
  transform: rotate(-180deg);
  transition: 300ms linear all;
}

.reloadOff {
  float: left;
  cursor: pointer;
  transform: rotate(180deg);
  transition: 300ms linear all;
}

div.search-area {
  padding-top: 12px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 6px !important;
  background-color: white;
  z-index: 1;
}

div.sticky1 {
  position: -webkit-sticky;
  position: sticky;
  top: 54px;
  padding-top: 6px;
  padding-right: 20px;
  padding-left: 20px;
  padding-bottom: 12px !important;
  background-color: white;
  z-index: 1;
}

input {
  background-color: rgba(249, 250, 252, 1);
}

.area-edit {
  background-color: white;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
}

.area-back {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 8px;
  padding-bottom: 8px;
}

.area-input {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 8px;
  padding-bottom: 8px;
}

.area-input label {
  font-size: 12px;
  color: rgba(154, 154, 154, 1);
  font-weight: 600;
  margin-bottom: 12px;
}

.area-input input, .area-input .model-select, .area-input .autocomplete {
  background-color: white;
  margin-bottom: 20px;
}

.area-button-submit {
  padding-left: 20px;
  padding-bottom: 20px;
  padding-top: 32px;
}

.select-invalid {
  border: 1px solid #e55353 !important;
}

.select-valid {
  border: 1px solid #2eb85c !important;
}

.btn-edit-submit {
  border-radius: 4px;
  float: left;
  width: 200px;
  background-color: rgba(48, 107, 221, 1);
  color: white;
  font-size: 14px;
}

.cards-image {
  position: absolute;
  text-align: center;
  font-size: 27px;
  color: rgba(96, 96, 96, 1);
  line-height: 50px;
  border: 1px dotted rgba(221, 221, 221, 1);
  width: 56px !important;
  background-color: rgba(250, 250, 250, 1);
  height: 56px !important;
}

.autocomplete {
  width: 100%;
  position: relative;
}

.input {
  cursor: text;
}

.close {
  position: absolute;
  right: 8px;
  top: 10px;
  background: none;
  border: none;
  font-size: 14px;
  color: lightgrey;
  cursor: pointer;
}

.placeholder {
  position: absolute;
  top: 7px;
  left: 16px;
  font-size: 14px;
  color: #d0d0d0;
}

.popovers {
  text-align: center;
  width: 100% !important;
  min-height: 50px;
  border: 1px solid #d8dbe0;
  position: absolute;
  top: 35px;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 8px;
  left: 0;
  right: 0;
  background: #fff;
  border-radius: 3px;
  text-align: center;
  z-index: 3;
}

.popovers input {
  right: 8px;
  left: 8px;
  width: 100%;
}

.options {
  max-height: 200px;
  overflow-y: auto;
  margin-top: 5px;
}

.options ul {
  list-style-type: none;
  text-align: left;
  padding-left: 0;
}

.options ul li {
  border-bottom: 1px solid lightgrey;
  padding: 10px;
  cursor: pointer;
  background: white;
}

.options ul li:first-child {
  border-top: 1px solid lightgray;
}

.options ul li:not(.selected):hover {
  background: whitesmoke;
  color: rgba(16, 16, 16, 1);
}

.options ul li.selected {
  background: whitesmoke;
  color: rgba(16, 16, 16, 1);
}
</style>
